import { RiErrorWarningLine } from 'react-icons/ri';
import { SizeProps, SpaceProps } from 'styled-system';
import { FC } from 'react';
import { HStack } from '@bpba/ui-components';

type Props = {
  size: SizeProps['size'];
  tabIndex?: number;
} & SpaceProps;

export const ErrorIcon: FC<Props> = ({ size, ...otherProps }) => {
  return (
    <HStack width={size} height={size} {...otherProps}>
      <RiErrorWarningLine size="100%" />
    </HStack>
  );
};

ErrorIcon.defaultProps = {
  tabIndex: -1,
};
